/**
 * @fileoverview POST handler for the "/engagement/campaigns/draft_active_campaign" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementCampaignsDraftActiveCampaignCacheKeys } from "./constants";
import type {
  PostEngagementCampaignsDraftActiveCampaignProps,
  PostEngagementCampaignsDraftActiveCampaignResult,
} from "./types";

export const postEngagementCampaignsDraftActiveCampaign = reactQueryMutationAdapter(
  postEngagementCampaignsDraftActiveCampaignCacheKeys,
  (
    props: PostEngagementCampaignsDraftActiveCampaignProps
  ): Promise<PostEngagementCampaignsDraftActiveCampaignResult> => {
    return fetch("/engagement/campaigns/draft_active_campaign", "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
